import { render, staticRenderFns } from "./inboxItem.vue?vue&type=template&id=2cf6e013&scoped=true"
import script from "./inboxItem.vue?vue&type=script&lang=js"
export * from "./inboxItem.vue?vue&type=script&lang=js"
import style0 from "./inboxItem.vue?vue&type=style&index=0&id=2cf6e013&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6e013",
  null
  
)

export default component.exports